import {
  getDevice
} from "@/config/utils";

/*
 * 打开外链url了
 *  参数：type “1”寿险，“2”车险订单，“3” 高端医疗
 */
export const appOpenOutWebView = (url, type) => {
  let t = +new Date()
  let baseUrl = url
  try {
    if (getDevice() == "android") {
      window.kbAndroid.openOutWebView(baseUrl, type);
    } else if (getDevice() == "ios" || getDevice() == "iPhoneX") {
      try {
        window.webkit.messageHandlers.openOutWebView.postMessage([baseUrl, type]);
      } catch (error) {
        openOutWebView(baseUrl, type);
      }
    }
  } catch (err) {
    console.log(err);
    window.open(baseUrl, "_self");
  }
};


export const appKbSaveImageToPhotoAlbum = base64 => {
  if (getDevice() == "android") {
    window.kbAndroid.kbSaveImageToPhotoAlbum(base64);
  } else if (getDevice() == "ios" || getDevice() == "iPhoneX") {
    try {
      window.webkit.messageHandlers.kbSaveImageToPhotoAlbum.postMessage([
        base64
      ]);
    } catch (error) {
      kbSaveImageToPhotoAlbum(base64);
    }
  }
};

export const appKbNewShareAction = share => {
  if (getDevice() == "android") {
    window.kbAndroid.kbNewShareAction(
      share[0],
      share[1],
      share[2],
      share[3],
      share[4]
    );
  } else if (getDevice() == "ios" || getDevice() == "iPhoneX") {
    try {
      window.webkit.messageHandlers.kbNewShareAction.postMessage([
        share[0],
        share[1],
        share[2],
        share[3],
        share[4]
      ]);
    } catch (error) {
      kbNewShareAction(share[0], share[1], share[2], share[3], share[4]);
    }
  }
};

export const kbSharePageAction = share => {
  if (getDevice() == "android") {
    window.kbAndroid.kbSharePageAction(
      share[0],
      share[1],
      share[2],
      share[3],
      share[4],
      share[5],
      share[6],
      share[7]
    );
  } else if (getDevice() == "ios" || getDevice() == "iPhoneX") {
    try {
      window.webkit.messageHandlers.kbSharePageAction.postMessage([
        share[0],
        share[1],
        share[2],
        share[3],
        share[4],
        share[5],
        share[6],
        share[7]
      ]);
    } catch (error) {
      kbSharePageAction(share[0],
        share[1],
        share[2],
        share[3],
        share[4],
        share[5],
        share[6],
        share[7]);
    }
  }
};


export const appKbImageShare = url => {
  if (getDevice() == "android") {
    window.kbAndroid.kbImageShare(url);
  } else if (getDevice() == "ios" || getDevice() == "iPhoneX") {
    try {
      window.webkit.messageHandlers.kbImageShare.postMessage([url]);
    } catch (error) {
      kbImageShare(url);
    }
  }
};

const userAgentInfo = window.navigator.userAgent;

/**是否APP打开*/
export const isTgjApp = () => {
  return userAgentInfo.toLowerCase().indexOf("tongguanjia") > -1;
};

//type 参数:1：h5⻚⾯加载完成 2：清理缓存
export const loadingPageFinish = type => {
  if (getDevice() == "android") {
    KBYAndroid.loadingPageFinish(type);
  } else if (getDevice() == "ios" || getDevice() == "iPhoneX") {
    try {
      window.webkit.messageHandlers.loadingPageFinish.postMessage([type]);
    } catch (error) {
      loadingPageFinish(type);
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/nativeApi.js